<template>
  <div>
    <div class="w-full h-full fixed left-0 top-0 bg-white bg-opacity-50 z-50" v-if="isLoading">
      <loader :label="$t('frontend_loading')"/>
    </div>
    <portal to="headerContent">
      <div class="flex items-center">
        <gd-button size="auto" class="px-10 h-10 ml-2" @click="visitBlog()"
          >{{ $t('frontend_grooveblog_visit_blog') }}</gd-button
        >
        <gd-button
          size="auto"
          class="px-10 h-10 ml-2"
          :class="{ disabled: blogQueued }"
          @click="publishBlog()"
          variant="primary"
          >{{ $t('frontend_publish') }}</gd-button
        >
      </div>
    </portal>
    <div class="relative bg-white main-wrapper" v-if="blogPublished">
      <div
        class="bg-white"
        style="margin: -12px -20px -20px; max-height: inherit"
      >
        <iframe
          id="homeIframe"
          :src="blogIframe"
          title="Grooveblog"
          style="width: 100%; height: calc(100vh - 65px); overflow: auto"
        ></iframe>
      </div>
    </div>
    <gd-banner
    v-if="publishSuccess"
    :text="$t('frontend_grooveblog_publish_progress_desc')"
    variant="success"
    :showIcon="true"
    position="bottom-right"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Loader from '@groovepages/gd-ui-kit/components/Loader';
import themeConfig from '@/theme/themeConfig.js';

export default {
  middleware: 'auth',
  layout: 'publish',
  metaInfo() {
    return { title: 'Publish' };
  },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      publishSuccess: false,
      blogIframe: '',
      blogUrl:'',
      blogPublished: false,
      blogSubdomain: '',
      blogQueued: false,
    };
  },
  components: { Loader },
  mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.$root.$on('refreshNavigation', () => {
      const iframe = document.getElementById('homeIframe');
      iframe.src = iframe.src;
    });
    this.checkPublishStatus();
  },
  methods: {
    getBlog() {
      this.showLoader();
      axios
        .get(`/blogs/${this.blogId}`)
        .then((response) => {
          this.blogIframe = response.data.data.preview_url;
          this.blogUrl= response.data.data.blog_url;
          this.blogSubdomain = response.data.data.sub_domain;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    publishBlog() {
      this.showLoader();
      this.publishSuccess = true;
      axios
        .post(`/publish/${this.blogId}`)
        .then(() => {
          this.checkQueueStatus();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    visitBlog() {
      window.open(this.blogUrl, '_blank');
    },
    sendToSetting() {
      this.$router.push({ name: 'general', query: { type: 'domain_setting' } });
    },
    checkPublishStatus() {
      this.showLoader();
        axios
          .get(`/check-blog-publish-status?blog_id=${this.blogId}`)
          .then((response) => {
            this.blogPublished = response.data;
            if (this.blogPublished) {
              this.checkQueueStatus();
            } else {
              this.publishSuccess = true;
              setTimeout(function () { this.checkPublishStatus() }.bind(this), 2000);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    checkQueueStatus() {
        axios
          .get(`/check-blog-queue-status?blog_id=${this.blogId}`)
          .then((response) => {
            this.blogQueued = response.data;
            if (!this.blogQueued) {
              this.getBlog();
              this.publishSuccess = false;
            } else {
              this.publishSuccess = true;
              this.hideLoader();
              setTimeout(function () { this.checkQueueStatus() }.bind(this), 2000);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
button.disabled {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>
